import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { ErrorStatusService } from './error-status.service';
import { toError } from './error-normalization-utils';
import * as Sentry from '@sentry/angular';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
  errorStatusService = inject(ErrorStatusService);
  authService = inject(AuthService);
  router = inject(Router);

  handleError(rawError: unknown): void {
    const error = toError(rawError);

    this.authService.handleNotLoggedInError(error);

    this.errorStatusService.setGlobalFatalError(true);

    console.error('[ErrorHandlerService] Caught global error:', error);

    const user = this.authService.currentUser();
    if (user) {
      Sentry.setUser({
        id: user.profile.id,
        email: user.profile.email,
      });
    }

    Sentry.setExtra('additional_info', {
      currentRoute: window.location.pathname,
      timestamp: new Date().toISOString(),
    });

    Sentry.captureException(error, {
      tags: {
        location: 'ErrorHandlerService',
        feature: 'GlobalErrorHandler',
        message: 'Unhandled global error',
      },
      extra: {
        message: '[ErrorHandlerService] Caught global error.',
      },
    });
  }
}
